export default {
    id: 'violet-orange',
    colors: ['#6B32C9', '#FF9580'],
};
